import { defineComponent } from "vue";
import { Grid } from "components/grid";
import { type FullAsset, type FullInvestment, type IInvestment } from "findef";
import { AssetImageV2 } from "components/asset-image-v2";

export const LockedByIRTooltip = defineComponent<{
  asset: FullAsset;
  investment?: FullInvestment | IInvestment;
}>({
  setup(props) {

    /* const shareholdersQuery = useMemoAsync(async () => {
      const [shareholders] = await FindexClient.getAssetShareholders(getRefId(props.asset))
      return shareholders as FindexUser[]
    }) */
    /* const shareholders = computed<(ShareholderWithInvestment & { name: string })[]>(() => {
      const holders = (shareholdersQuery.loading ? [] : shareholdersQuery.data || []).map(
        (holder): ShareholderWithInvestment & { name: string } => {
          const investment = (holder.investments || []).find(
            (it) => getAssetId(it.asset) === props.asset._id
          ) as FindexInvestment

          return {
            ...holder,
            investment: investment,
            icon: investment?.ownedBy?.name && RocketIcon,
            name: investment?.ownedBy?.name ? investment?.ownedBy.name : `${holder.firstname} ${holder.lastname}`
          }
        }
      )
      return holders
      }) */

    return () => {
      return (
        <div class="min-w-[16rem]">
          <Grid
            columns="max-content auto"
            class="h-16 p-3 bg-purple-100 justify-start items-start gap-2"
            alignItems="center"
          >
            <div
              class="w-10 h-10 text-gray-500"
              style={{
                width: '100%',
              }}
            >
              <AssetImageV2
                asset={props.asset}
                size="md"
                variant="gray"
                objectFit="cover"
                iconProps={{ size: "1.5rem" }}
              />
            </div>
            <Grid noDefaultLayout rows="max-content max-content" alignItems="center">
              <div class="text-purple-500 text-xs font-semibold font-['Inter'] leading-[18px]">
                {props.asset.name}
              </div>
              <div class="text-gray-500 text-xs font-normal font-['Inter'] leading-[18px]">
                IR Company
              </div>
            </Grid>
          </Grid>
          <div class="divide-y divide-gray-200">
            <Grid class="p-3 bg-white" columns="max-content" justifyContent="space-between">
              <Grid
                class="text-gray-900 text-xs font-medium font-['Inter'] leading-3"
                alignItems="center"
                noDefaultLayout
              >
                This field is maintained by an IR administrator
              </Grid>
            </Grid>
          </div>
        </div>
      )
    }
  }
})

LockedByIRTooltip.props = ['asset', 'investment']
